import { createContext, useContext } from 'react';

export type FormatMode = 'formatted' | 'raw';

export const FormatContext = createContext<FormatMode>('formatted');

export const useFormatMode = (): FormatMode => useContext(FormatContext);
